import { getAiApiUrl } from '../../config';
import { storage } from '../../lib/storage';
import { notify } from '../../utils/toast';

export const updateTokenUsage = async (
  auth: { jwt: string; walletAddress: string; nonce: string },
  usage: {
    prompt_tokens: number;
    completion_tokens: number;
    total_tokens: number;
  }
) => {
  try {
    const response = await fetch(`${getAiApiUrl()}/v1/tokens`, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        'Authorization': `Bearer ${auth.jwt}`
      },
      body: JSON.stringify({
        walletAddress: auth.walletAddress,
        nonce: auth.nonce,
        tokens: {
          prompt: usage.prompt_tokens,
          completion: usage.completion_tokens,
          total: usage.total_tokens
        }
      })
    });

    if (!response.ok) {
      throw new Error('Failed to update token usage');
    }

    const data = await response.json();
    
    // Update profile with new credit amount
    const profile = await storage.getProfile(auth.walletAddress);
    if (profile) {
      await storage.setProfile(auth.walletAddress, {
        ...profile,
        credit: data.credit
      });
    }

    return data.credit;
  } catch (error) {
    console.error('Error updating token usage:', error);
    throw error;
  }
};